import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Session } from './session.model';

@Injectable({
  providedIn: 'root',
})
export class SessionService {
  constructor(private http: HttpClient) {}

  getSession(): Session {
    return JSON.parse(sessionStorage.getItem('session'));
  }

  login(params): Observable<Session> {
    return this.http.post<Session>('/sessions', params);
  }

  logout(): Observable<Session> {
    return this.http.delete<Session>('/sessions/' + this.getSession().id);
  }

  validateToken(params): Observable<Session> {
    return this.http.post<Session>('/sessions', { jwt: 'Bearer ' + params });
  }

}
